export enum CountryCode {
	SE = "SE",
	GB = "GB",
}

export enum CountrySubdivision {
	Wales = "WLS",
	Scotland = "SCT",
	NortherIreland = "NIR",
	England = "ENG",
}

export const getSubdivisions = {
	GB: ["NIR", "SCT", "WLS", "ENG"],
};
